export enum AppDirection {
	RTL = 'rtl',
	LTR = 'ltr',
}
